import React, { useRef, useState, useEffect } from 'react'
import Slider from 'react-slick'
import { RealEstateDataPageComponentData, Partner } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'gatsby'

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  items: 3,
  slidesToShow: 3,
  centerMode: true,
  centerPadding: `${screen.width / 15}px`,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 3000,
  arrows: false,
  pauseOnHover: false,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        items: 3,
        slidesToShow: 3,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 992,
      settings: {
        items: 3,
        slidesToShow: 3,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 768,
      settings: {
        items: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
}

const MOCKDATA: RealEstateDataPageComponentData = {
  title: 'Estos son nuestros Partners',
  paragraph: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Non doloribus explicabo.",
  button: {
    link: "nosotros",
    value: "CONOCÉ MÁS"
  },
  partners: [
    {
      id: 1,
      link: "https://link.partner.com/4x3jfQ7P",
      image: "https://i.postimg.cc/4x3jfQ7P/logo1.png",
      title: "SemanticBits",
      description: "Laudantium enim quasi est quidem magnam voluptate ipsam eos tempora quo quasi aspernatur aut expedita occaecati aliquamnec enim quasi est quidem magnam voluptate essitat."
    },
    {
      id: 2,
      image: "https://i.postimg.cc/nLj57V1Q/logo3.png",
      title: "Battleaxe",
      description: "Quia molestiae enim quasi est quidem magnam voluptate reprehenderit quasi aspernatur aut expedita occaecati aliquam eveniet laudantium omnis quibusdam delectus."
    },
    {
      id: 3,
      link: "https://link.partner.com/25stxpH9",
      image: "https://i.postimg.cc/25stxpH9/logo5.png",
      title: "Kraft Heinz",
      description: "With enim quasi est quidem magnam voluptate supporting text below quasi aspernatur aut expedita occaecati aliquamas a natural lead-in to additional content.",
    },
    {
      id: 4,
      link: "https://link.partner.com/zGP6VHTr",
      image: "https://i.postimg.cc/zGP6VHTr/logo8.png",
      title: "KP Capital",
      description: "Wquas enim quasi est quidem magnam voluptate accusantium unde quasi aspernatur aut expedita occaecati aliquam odit nobis qui voluptatem quia voluptas consequuntur itaque."
    }
  ]
}

const GoogleReviews = (props: RealEstateDataPageComponentData) => {

  const { isDemo } = props
  const { title, partners, paragraph, button } = isDemo ? MOCKDATA : props;
  
  // Loader effect
  const [load, setLoad] = useState(true)
  useEffect(() => {
    setTimeout(() => {
      setLoad(() => false)
    }, 3000)
  }, [])
  
  const sliderRef = useRef<any>()
  const Partner = require(`@components/cards-partners/1`)?.default

  return (
    <section id="partners" className={'pr' + (partners?.length === 0 ? 'd-none' : '')}>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <h2 className="section-title pb-lg-5">{title}</h2>
          </Col>
        </Row>
      </Container>
      <div className="partners-container d-flex align-items-center justify-content-center my-4">
        <Slider
          ref={sliderRef}
          {...settings}
          lazyLoad="ondemand"
          className="overflow-hidden">
          { load
            ? [1, 2, 3, 4, 5, 6].map((index) => (
                <Partner
                  key={index}
                  skeleton={true}
                />
              ))
            : partners?.map((partner: Partner, index: number) => (
                <Partner
                  key={index}
                  partner={partner}
                />
              ))}
        </Slider>
          <i className="d-block icon-arrow-left isArrowFeatured"
             onClick={() => sliderRef.current.slickPrev()}></i>
          <i className="d-block icon-arrow isArrowFeatured"
             onClick={() => sliderRef.current.slickNext()}></i>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="d-flex flex-column align-items-center justify-content-center mt-4">
            {paragraph && <p className="text-center mb-4">{paragraph}</p>}
            {(button && Object.keys(button)) && 
              <Link to={button?.link || ""}
                  className="btn btn-primary">
                  {button?.value}
              </Link>}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default GoogleReviews
